import { render, staticRenderFns } from "./appActu.vue?vue&type=template&id=2a24c1bc&scoped=true"
import script from "./appActu.vue?vue&type=script&lang=js"
export * from "./appActu.vue?vue&type=script&lang=js"
import style0 from "./appActu.vue?vue&type=style&index=0&id=2a24c1bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a24c1bc",
  null
  
)

export default component.exports